import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  fetchSystemEventCheckAll,
  fetchSystemeventDeleteAll,
  fetchSystemEventGetAll,
} from '../../services/system-event.service';
import { TSystemEventGetAllPayload } from '../../types/@system-event';
import { notificationActions } from '../slices/notification.slice';
import { systemEventActions } from '../slices/system-event.slice';

function* getAllSystemEvent({
  payload,
}: PayloadAction<TSystemEventGetAllPayload>): SagaIterator {
  try {
    const fetchResult: any = yield call(fetchSystemEventGetAll, payload?.page);
    yield put({
      type: systemEventActions['getAll/Ok'].type,
      payload: fetchResult?.data || { data: [], pages: 0 },
    });
    yield put({ type: systemEventActions.setIsLoaded.type, payload: true });
  } catch (err) {
    yield put({ type: systemEventActions['getAll/Err'].type, payload: err });
    yield put({ type: systemEventActions.setIsLoaded.type, payload: true });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* checkAllSystemEvent(): SagaIterator {
  try {
    yield call(fetchSystemEventCheckAll);
    yield put({ type: systemEventActions['checkAll/Ok'].type });
    yield put({ type: systemEventActions.getAll.type, payload: { page: 1 } });
  } catch (err) {
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* deleteAllSystemEvent(): SagaIterator {
  try {
    yield call(fetchSystemeventDeleteAll);
    yield put({ type: systemEventActions['deleteAll/Ok'].type });
    yield put({
      type: systemEventActions['getAll/Ok'].type,
      payload: { data: [], pages: 0 },
    });
  } catch (err) {
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

export function* watchSystemEvent(): SagaIterator {
  yield takeLatest(systemEventActions.getAll.type, getAllSystemEvent);
  yield takeLatest(systemEventActions.checkAll.type, checkAllSystemEvent);
  yield takeLatest(systemEventActions.deleteAll.type, deleteAllSystemEvent);
}